import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_COM',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '69b80914-3006-4e3f-5aef-9f66e173522e',
  ''
);
